import { AlertTriangle, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import DashboardSection from "../components/DashboardSection";

function quantity(value) {
  const amount = Number(value || 0);
  return Number.isInteger(amount) ? String(amount) : amount.toFixed(3).replace(/0+$/, "").replace(/\.$/, "");
}

function LowStockPanel({ items }) {
  const navigate = useNavigate();
  const rows = items || [];
  return (
    <DashboardSection
      title="Low Stock"
      description="Inventory items that may need attention soon."
      action={<button type="button" className="admin-link-button" onClick={() => navigate("/admin/inventory")}>Inventory<ArrowRight size={16} /></button>}
    >
      <div className="low-stock-list">
        {rows.length ? rows.map((item) => (
          <article className="low-stock-item" key={item.id}>
            <span className="low-stock-item__icon"><AlertTriangle size={18} /></span>
            <div><strong>{item.name}</strong><span>{quantity(item.remaining)} {item.unit} remaining</span></div>
          </article>
        )) : <p className="admin-dashboard-empty">No low-stock items right now.</p>}
      </div>
    </DashboardSection>
  );
}

export default LowStockPanel;
